import Segment from './src/segment.vue';
import { SFCWithInstall, withInstall } from '@touchvue/utils';

export const ToSegment: SFCWithInstall<typeof Segment> = withInstall(Segment);

export * from './src/instance';